import { createSlice } from '@reduxjs/toolkit';

import { BlogsAxios } from '../../axios/blogs/blogs.axios';
import { AtiraThunk } from '../AtiraThunk';

interface BlogsReducer {
  blogs: any[];
  blogsLoading: boolean;
}

const initialState = Object.freeze<BlogsReducer>({
  blogs: [],
  blogsLoading: false,
});

const getBlogs = AtiraThunk<any[], void>('/blogs/', BlogsAxios.getBlogs);

const blogsSlice = createSlice({
  name: 'blogs',
  initialState,
  reducers: {},
  extraReducers: ({ addCase }) => {
    addCase(getBlogs.pending, (state) => {
      state.blogsLoading = true;
    });

    addCase(getBlogs.fulfilled, (state, action) => {
      state.blogs = action.payload;
      state.blogsLoading = false;
    });

    addCase(getBlogs.rejected, (state) => {
      state.blogsLoading = false;
    });
  },
});

export const blogsActions = {
  getBlogs,
};

export default blogsSlice.reducer;
